"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constant_1 = require("./column/constant");
var RowShift_1 = require("./table/RowShift");
var TimeShift_1 = require("./table/TimeShift");
exports.DefaultTransformRegistry = {
    'time-shift': TimeShift_1.timeShift,
    'row-shift': RowShift_1.rowShift,
    constant: constant_1.constantColumnTransformCreator,
};
//# sourceMappingURL=DefaultTransformRegistry.js.map